import { Controller } from "@hotwired/stimulus"

// サイドバーのグループ開閉（汎用の disclosure パターン）。
// content の表示/非表示を切り替え、icon を回転させる
export default class extends Controller {
  static targets = ["content", "icon"]

  toggle() {
    this.contentTarget.classList.toggle("hidden")
    this.iconTarget.classList.toggle("rotate-90")
  }
}
